import appConfig from "../appconfig";
import {BifrostBackendApi} from "../gateways/BifrostBackendApi";

const ProductsIngredientsProvider = Object.freeze({
	getProductsIngredientsByIngredientId(ingredientId){
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			ingredientId: ingredientId
		};

		return Promise.all([
			BifrostBackendApi.get("/products-ingredients", {
				params: ingredientsQueryParams
			})
		]).then(([ productsIngredients]) => {
			return {
				productsIngredients
			};
		});
	},
	getProductsIngredientsByProductId(productId){
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			productId: productId
		};
		return Promise.all([
			BifrostBackendApi.get("/products-ingredients", {
				params: ingredientsQueryParams
			})
		]).then(([ productsIngredients]) => {
			return {
				productsIngredients
			};
		});
	},
	getAllProductsIngredients(){
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId
		};
		return Promise.all([
			BifrostBackendApi.get("/products-ingredients", {
				params: ingredientsQueryParams
			})
		]).then(([ productsIngredients]) => {
			return {
				productsIngredients
			};
		});
	},
	createNewProductIngredient(productIngredient, jwtToken) {
		return BifrostBackendApi.post(`/products-ingredients/?tenantId=${productIngredient.tenantId}`, productIngredient, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	updateProductIngredient(ingredient, jwtToken) {
		return BifrostBackendApi.put(`/products-ingredients/${ingredient.productId}`, ingredient, {
			params: {tenantId: appConfig.tenantId},
			headers: {
				Authorization: jwtToken
			}
		});
	},
	deleteProductIngredient(productIngredient, jwtToken) {
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			ingredientId: productIngredient.ingredientId,
			productId: productIngredient.productId
		};

		return Promise.all([
			BifrostBackendApi.delete("/products-ingredients", {
				params: ingredientsQueryParams,
				headers: {
					Authorization: jwtToken
				}
			})
		]).then(([ productsIngredients]) => {
			return {
				productsIngredients
			};
		});
	},
	deleteProductsIngredients(ingredient, jwtToken) {
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			ingredientId: ingredient.id
		};
		return Promise.all([
			BifrostBackendApi.delete("/products-ingredients", {
				params: ingredientsQueryParams,
				headers: {
					Authorization: jwtToken
				}
			})
		]).then(([ productsIngredients]) => {
			return {
				productsIngredients
			};
		});
	}
});

export default ProductsIngredientsProvider;
